export default __webpack_public_path__ + "static/media/you-top.3e4afad7.png";